import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import bind from "memoize-bind";

import CSSModules from "lib/utils/css-modules";
import { OrderDecorator } from "lib/index";
import { rejectOrderWithConfirm, approveOrderWithConfirm } from "modules/orders/utils";
import OrdersListItem from "./OrdersListItem";
import styles from "./List.less";

@connect(
  (state) => ({
    currentCompanyId: state.auth.company.model.id,
    orderActionPendingById: state.orders.utils.orderActionPendingById,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        rejectOrderWithConfirm,
        approveOrderWithConfirm,
      },
      dispatch
    )
)
@CSSModules(styles)
export default class OrdersList extends React.PureComponent {
  render() {
    const {
      orders,
      currentCompanyId,
      rejectOrderWithConfirm,
      approveOrderWithConfirm,
      orderActionPendingById,
      ...rest
    } = this.props;
    return (
      <div styleName="list">
        {orders.map((order) => (
          <OrdersListItem
            key={order.id}
            order={order}
            currentCompanyId={currentCompanyId}
            onApprove={bind(approveOrderWithConfirm, null, order)}
            onReject={bind(rejectOrderWithConfirm, null, order)}
            actionPending={orderActionPendingById[order.id] === true}
            {...rest}
          />
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/list/OrdersList.jsx